import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"

import { API_C2C_URL } from "../constants"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

async function confirm(token: string | null, outcomeTransferId: string) {
  const response = await axios(`${API_C2C_URL}/${outcomeTransferId}/accept`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: outcomeTransferId,
  })
  if (checkIsFailure(response.status)) {
    throw new Error(`${response.status}`)
  }
}

export const useConfirmSbpOutcomeTransfer = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<void, string, string>({
    mutationFn: (outcomeTransferId) => confirm(token, outcomeTransferId),
  })
}
